import React from "react"
import DefaultLayout from "../../components/layout/DefaultLayout"
import { Row, Col, Container } from "react-bootstrap"
import { PreEnrolmentTable } from "../../components/pre-enrolmentTable/PreEnrolmentTable"

const PreEnrolment = () => {
  // const { add } = useParams()

  return (
    <DefaultLayout>
      <Container>
        <div className="">
          <Row className="py-2">
            <Col>
              <h5>Pre-Enrolments</h5>
            </Col>
          </Row>
          <Row>
            <Col>
              <PreEnrolmentTable />
            </Col>
          </Row>
        </div>
      </Container>
    </DefaultLayout>
  )
}

export default PreEnrolment
